var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('roe-article-form',{ref:"form",attrs:{"articles":_vm.reportSavingArticles,"category-articles":_vm.savingArticles}}),_c('roe-article-list',{attrs:{"articles":_vm.reportSavingArticles,"article-form":_vm.$refs.form}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }